interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  hover?: boolean
  padding?: boolean
}

const Card = ({ children, className = '', hover = false, padding = true, ...props }: CardProps) => (
  <div className={`${hover ? 'card-hover' : 'card'} ${padding ? 'p-6' : ''} ${className}`} {...props}>{children}</div>
)

const CardHeader = ({ children, className = '' }: { children: React.ReactNode; className?: string }) => <div className={`mb-4 ${className}`}>{children}</div>
const CardTitle = ({ children, className = '' }: { children: React.ReactNode; className?: string }) => <h3 className={`text-lg font-semibold text-gray-900 ${className}`}>{children}</h3>
const CardDescription = ({ children, className = '' }: { children: React.ReactNode; className?: string }) => <p className={`text-sm text-gray-500 mt-1 ${className}`}>{children}</p>
const CardContent = ({ children, className = '' }: { children: React.ReactNode; className?: string }) => <div className={className}>{children}</div>
const CardFooter = ({ children, className = '' }: { children: React.ReactNode; className?: string }) => <div className={`mt-4 pt-4 border-t border-gray-100 ${className}`}>{children}</div>

Card.Header = CardHeader
Card.Title = CardTitle
Card.Description = CardDescription
Card.Content = CardContent
Card.Footer = CardFooter

export default Card
